import http from '@/biz/http.mjs'

export default () => http
